{
	"_comment": "This file is updated by the build process. Do not edit it manually.",
	"version": "1.79.0",
	"hash": "ef31eddea1ebb939a147332ed581f36473961f32"
}
